import { Api } from '@oneclass/ui-components';

// 回報題目
export const postQuestionReport = async (payload) => {
  const response = await Api.post(`${process.env.REACT_APP_DOMAIN}/api/Question/Report`, payload);
  return response;
};

